import type React from "react";
import "./_base-button.scss";

interface BaseButtonProps
	extends React.ButtonHTMLAttributes<HTMLButtonElement> {
	variant?: "primary" | "secondary" | "danger" | "ghost";
	size?: "sm" | "md" | "lg";
	icon?: React.ReactNode;
	fullWidth?: boolean;
}

export const BaseButton: React.FC<BaseButtonProps> = ({
	variant = "primary",
	size = "md",
	icon,
	fullWidth = false,
	children,
	className = "",
	disabled,
	type = "button",
	...props
}) => {
	const classes = [
		"base-button",
		`base-button--${variant}`,
		`base-button--${size}`,
		fullWidth ? "base-button--full-width" : "",
		disabled ? "base-button--disabled" : "",
		className,
	]
		.filter(Boolean)
		.join(" ");

	return (
		<button type={type} className={classes} disabled={disabled} {...props}>
			{icon && <span className="base-button__icon">{icon}</span>}
			{children && <span className="base-button__text">{children}</span>}
		</button>
	);
};
